import {
  IonButton,
  IonItem,
  IonList,
  IonPopover,
  IonRadio,
  IonRadioGroup,
  IonRefresher,
  IonRefresherContent,
  IonSkeletonText,
  useIonToast,
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonIcon,
  IonContent,
  IonAccordionGroup,
  IonAccordion,
  IonFooter,
  IonLabel,
  IonSearchbar,
  IonInput,
  IonGrid,
  IonCol,
  IonRow,
} from "@ionic/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { CardComponent } from "../components/Cards/StoreCard";
import useInterval from "use-interval";
import { analyticFrequencyInMS, sendAnalytics } from "../components/functions";
import { useSelector } from "react-redux";
import MyPortal from "../components/MyPortal";
import dayjs from "dayjs";
import SortFunctions from "../components/SortFunctions";
import { useHistory } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import {
  funnel as funnelOutline,
  close as closeOutline,
  funnelSharp,
  search as searchOutline,
} from "ionicons/icons";

const fields = [
  { label: "TS", dataIndex: "today_amt" },
  { label: "YS", dataIndex: "yesterday_amt" },
  { label: "WTD", dataIndex: "this_week_amt" },
  { label: "MTD", dataIndex: "this_month_amt" },
  { label: "", dataIndex: "ts_last_year_amt" },
  { label: "", dataIndex: "ys_last_year_amt" },
  { label: "", dataIndex: "ws_last_year_amt" },
  { label: "", dataIndex: "ms_last_year_amt" },
  { label: "TSGR%", dataIndex: "today_growth_pct" },
  { label: "YSGR%", dataIndex: "yesterday_growth_pct" },
  { label: "WTDGR%", dataIndex: "week_growth_pct" },
  { label: "MTDGR%", dataIndex: "month_growth_pct" },
];

export default function ETHData() {
  const history = useHistory();
  const ethBase = history.location.pathname.startsWith("/legacy/") ? "/legacy" : "";
  const authReducer = useSelector((state) => state.authReducer);
  const [details, setDetails] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [present] = useIonToast();
  const [sortState, setSortState] = React.useState({ key: null, direction: null });
  const { handleAscSort, handleDesSort } = SortFunctions({
    details,
    setSortState,
    setDetails,
  });
  const [storeTypeFilter, setStoreTypeFilter] = React.useState(null);
  const [isSortPopoverOpen, setIsSortPopoverOpen] = React.useState(false);
  const [isMobileFilterDrawerOpen, setIsMobileFilterDrawerOpen] = React.useState(false);
  const [selectedSortOption, setSelectedSortOption] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const [storeResults, setStoreResults] = useState([]);
  const [storeLoading, setStoreLoading] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const filtersApplied = storeTypeFilter !== null || sortState.key !== null;

  function handleDSort() {
    window.location.reload(true);
  }

  const getData = async (refreshEvent) => {
    setLoading(true);
    try {
      const params = {
        summary: "state",
        store_type: storeTypeFilter || undefined,
      };

      const res = await axios.get("/ethnicity/get_sales_data", { params });

      const formatToLakh = (value) => (value / 100000).toFixed(2);

      let mapped = res.data.data.map((item) => ({
        ...item,
        store_count: item.store_count ?? 0,
        ts_last_year_amt: `${formatToLakh(item.ts_last_year_amt || 0)} `,
        ys_last_year_amt: `${formatToLakh(item.ys_last_year_amt || 0)} `,
        ws_last_year_amt: `${formatToLakh(item.ws_last_year_amt || 0)} `,
        ms_last_year_amt: `${formatToLakh(item.ms_last_year_amt || 0)} `,
      }));

      let finalDetails = mapped;

      if (sortState.key && sortState.direction) {
        finalDetails = [...finalDetails].sort((a, b) => {
          const aVal = a[sortState.key] ?? 0;
          const bVal = b[sortState.key] ?? 0;
          return sortState.direction === "asc" ? aVal - bVal : bVal - aVal;
        });
      }

      setDetails([
        mapped?.find((item) => item?.store_name === "Ethnicity"),
        ...finalDetails?.filter((item) => item?.store_name !== "Ethnicity"),
      ]);
    } catch (err) {
      present({
        message: err?.response?.data?.message || "Error Occurred",
        duration: 2000,
        color: "danger",
      });
    }
    setLoading(false);
    refreshEvent?.detail?.complete();
  };

  useEffect(() => {
    async function fetchStores() {
      setStoreLoading(true);
      try {
        const res = await axios.get("/ethnicity/get_sales_data", { params: { summary: "store" } });
        const formatToLakh = (value) => (value / 100000).toFixed(2);
        setStoreResults(
          (res.data.data || []).map((item) => ({
            ...item,
            ts_last_year_amt: `${formatToLakh(item.ts_last_year_amt || 0)} `,
            ys_last_year_amt: `${formatToLakh(item.ys_last_year_amt || 0)} `,
            ws_last_year_amt: `${formatToLakh(item.ws_last_year_amt || 0)} `,
            ms_last_year_amt: `${formatToLakh(item.ms_last_year_amt || 0)} `,
          }))
        );
      } catch (err) {
        setStoreResults([]);
      }
      setStoreLoading(false);
    }
    fetchStores();
  }, []);

  useEffect(() => {
    if (searchText) {
      setDetails([]);
    } else {
      getData();
    }
  }, [searchText, storeTypeFilter, sortState]);

  useInterval(() => {
    if (document.visibilityState === "visible") {
      sendAnalytics("2", authReducer.user.userId, authReducer.user.username);
    }
  }, analyticFrequencyInMS);

  useEffect(() => {
    sendAnalytics("2", authReducer.user.userId, authReducer.user.username);
  }, []);

  const filteredStores = storeResults.filter((item) =>
    item.store_name?.toLowerCase().includes((searchText || "").toLowerCase())
  );

  const handleRegionClick = (item) => {
    const query = storeTypeFilter ? `?storeType=${storeTypeFilter}` : "";
    if (item.store_name === "Ethnicity") {
      history.push(`${ethBase}/sales/eth/region/All STORES${query}`);
    } else {
      history.push(`${ethBase}/sales/eth/region/${encodeURIComponent(item.store_name)}${query}`);
    }
  };

  return (
    <div
      style={{
        display: "inline-flex",
        justifyContent: "space-around",
        width: "100%",
        flexWrap: "wrap",
        position: "relative",
        paddingBottom: "50px",
      }}
    >
      <IonRefresher slot="fixed" onIonRefresh={getData}>
        <IonRefresherContent></IonRefresherContent>
      </IonRefresher>

      {loading &&
        !details?.length &&
        Array.from({ length: 10 }).map((_, i) => (
          <IonSkeletonText key={i} animated style={{ height: "150px" }} />
        ))}

      <MyPortal id="navbar-portal-div">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div style={{ flex: "1 1 auto", minWidth: 0 }}>
            <div
              style={{
                fontWeight: isMobile ? 200 : 500,
                fontSize: isMobile ? "0.9rem" : "1.5rem",
                display: "grid",
                textAlign: "left",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                marginRight: isMobile ? "0.1rem" : "0",
              }}
            >
              Ethnicity
              <span style={{ fontSize: "0.8rem", marginTop: "0.2rem" }}>
                {details?.[0]?.updated_at &&
                  dayjs(details?.[0]?.updated_at).fromNow()}
              </span>
            </div>
          </div>

          <div>
            {isMobile ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "6px",
                    alignItems: "center",
                    marginRight: "6px",
                  }}
                >
                  <IonButton
                    size="small"
                    fill={storeTypeFilter === "LTL" ? "solid" : "outline"}
                    onClick={() =>
                      setStoreTypeFilter(storeTypeFilter === "LTL" ? null : "LTL")
                    }
                  >
                    LTL
                  </IonButton>
                  <IonButton
                    size="small"
                    fill={storeTypeFilter === "PTL" ? "solid" : "outline"}
                    onClick={() =>
                      setStoreTypeFilter(storeTypeFilter === "PTL" ? null : "PTL")
                    }
                  >
                    PTL
                  </IonButton>
                </div>
                <IonButton
                  fill="clear"
                  size="small"
                  onClick={() => setIsSearchModalOpen(true)}
                >
                  <IonIcon icon={searchOutline} />
                </IonButton>
                <IonButton
                  fill="clear"
                  size="small"
                  onClick={() => setIsMobileFilterDrawerOpen(true)}
                >
                  <IonIcon icon={filtersApplied ? funnelSharp : funnelOutline} />
                </IonButton>
              </div>
            ) : (
              <div style={{ display: "inline-flex", alignItems: "center" }}>
                <div style={{ height: "20px", marginRight: "10px" }}>
                  <IonSearchbar
                    value={searchText}
                    onIonInput={(e) => setSearchText(e.target.value)}
                    placeholder="Search Store..."
                    debounce={300}
                  />
                </div>
                <div style={{ display: "flex", gap: "0.5rem" }}>
                  <IonButton
                    color="primary"
                    fill={storeTypeFilter === "LTL" ? "solid" : "outline"}
                    onClick={() => setStoreTypeFilter("LTL")}
                  >
                    LTL
                  </IonButton>
                  <IonButton
                    color="primary"
                    fill={storeTypeFilter === "PTL" ? "solid" : "outline"}
                    onClick={() => setStoreTypeFilter("PTL")}
                  >
                    PTL
                  </IonButton>
                  <IonButton
                    color="primary"
                    fill={storeTypeFilter === "NEW_STORE" ? "solid" : "outline"}
                    onClick={() => setStoreTypeFilter("NEW_STORE")}
                  >
                    NEW_STORE
                  </IonButton>
                </div>
                <IonButton
                  size="default"
                  color="white"
                  id="popover-eth-button"
                  onClick={() => setIsSortPopoverOpen(!isSortPopoverOpen)}
                >
                  Sort By
                </IonButton>
              </div>
            )}
          </div>
        </div>
      </MyPortal>

      <div
        className="cards-container"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: isMobile ? "0.5rem" : "1rem",
          padding: isMobile ? "0.5rem" : "1rem",
          width: "100%",
          justifyContent: "center",
        }}
      >
        {details.map((item, index) => (
          <div
            key={index}
            onClick={() => handleRegionClick(item)}
            style={{
              cursor: "pointer",
              flexBasis: isMobile ? "100%" : "calc(50% - 1rem)",
              maxWidth: isMobile ? "100%" : "400px",
              minWidth: isMobile ? "auto" : "300px",
            }}
          >
            <CardComponent
              data={item}
              fields={fields}
              fieldsInOneRow={4}
              showStoreCountRight={item.store_name !== "Ethnicity"}
            />
            <IonButton
              expand="block"
              style={{
                width: "91%",
                alignSelf: "center",
                marginRight: "0.5rem",
                marginLeft: "0.5rem",
                height: "42px",
                "--background": "linear-gradient(135deg, #4b4b4b, #2c2c2c)",
                "--color": "#ffffff",
                "--border-radius": "12px",
                fontWeight: "600",
                letterSpacing: "0.6px",
                textTransform: "uppercase",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
                transition: "transform 0.2s, box-shadow 0.2s",
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleRegionClick(item);
              }}
            >
              View Store
            </IonButton>
          </div>
        ))}
      </div>

      {searchText && (
        <div
          className="cards-container"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: isMobile ? "0.5rem" : "1rem",
            padding: isMobile ? "0.5rem" : "1rem",
            width: "100%",
            justifyContent: "center",
          }}
        >
          {filteredStores
            .filter((item) => item.store_name !== "Ethnicity")
            .map((item, index) => (
              <div key={index} style={{ maxWidth: "400px", minWidth: "300px" }}>
                <CardComponent data={item} fields={fields} fieldsInOneRow={4} />
              </div>
            ))}
          {!storeLoading &&
            filteredStores.filter((item) => item.store_name !== "Ethnicity").length === 0 && (
              <div style={{ textAlign: "center", width: "100%", marginTop: "2rem" }}>
                No stores found.
              </div>
            )}
        </div>
      )}

      {/* Desktop Sort Popover */}
      <IonPopover
        isOpen={isSortPopoverOpen}
        trigger="popover-eth-button"
        keepContentsMounted
        dismissOnSelect={false}
        side="bottom"
        size="auto"
        className="wide-popover"
      >
        <IonContent className="ion-padding">
          <IonAccordionGroup expand="first">
            <IonItem
              button
              onClick={() => {
                setSelectedSortOption("default");
                handleDSort("default");
              }}
            >
              <IonLabel><b>Default</b></IonLabel>
            </IonItem>

            <IonAccordion value="ts">
              <IonItem slot="header"><IonLabel>TS</IonLabel></IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup
                  value={selectedSortOption}
                  onIonChange={(e) => {
                    const value = e.detail.value;
                    setSelectedSortOption(value);
                    if (value === "ts_asc") handleAscSort("today_amt");
                    else if (value === "ts_desc") handleDesSort("today_amt");
                    setIsSortPopoverOpen(false);
                  }}
                >
                  <IonItem><IonLabel>Low to High</IonLabel><IonRadio slot="end" value="ts_asc" /></IonItem>
                  <IonItem><IonLabel>High to Low</IonLabel><IonRadio slot="end" value="ts_desc" /></IonItem>
                </IonRadioGroup>
              </div>
            </IonAccordion>

            <IonAccordion value="ys">
              <IonItem slot="header"><IonLabel>YS</IonLabel></IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup
                  value={selectedSortOption}
                  onIonChange={(e) => {
                    const value = e.detail.value;
                    setSelectedSortOption(value);
                    if (value === "ys_asc") handleAscSort("yesterday_amt");
                    else if (value === "ys_desc") handleDesSort("yesterday_amt");
                    setIsSortPopoverOpen(false);
                  }}
                >
                  <IonItem><IonLabel>Low to High</IonLabel><IonRadio slot="end" value="ys_asc" /></IonItem>
                  <IonItem><IonLabel>High to Low</IonLabel><IonRadio slot="end" value="ys_desc" /></IonItem>
                </IonRadioGroup>
              </div>
            </IonAccordion>

            <IonAccordion value="wtds">
              <IonItem slot="header"><IonLabel>WTDS</IonLabel></IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup
                  value={selectedSortOption}
                  onIonChange={(e) => {
                    const value = e.detail.value;
                    setSelectedSortOption(value);
                    if (value === "wtds_asc") handleAscSort("this_week_amt");
                    else if (value === "wtds_desc") handleDesSort("this_week_amt");
                    setIsSortPopoverOpen(false);
                  }}
                >
                  <IonItem><IonLabel>Low to High</IonLabel><IonRadio slot="end" value="wtds_asc" /></IonItem>
                  <IonItem><IonLabel>High to Low</IonLabel><IonRadio slot="end" value="wtds_desc" /></IonItem>
                </IonRadioGroup>
              </div>
            </IonAccordion>

            <IonAccordion value="mtds">
              <IonItem slot="header"><IonLabel>MTDS</IonLabel></IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup
                  value={selectedSortOption}
                  onIonChange={(e) => {
                    const value = e.detail.value;
                    setSelectedSortOption(value);
                    if (value === "mtds_asc") handleAscSort("this_month_amt");
                    else if (value === "mtds_desc") handleDesSort("this_month_amt");
                    setIsSortPopoverOpen(false);
                  }}
                >
                  <IonItem><IonLabel>Low to High</IonLabel><IonRadio slot="end" value="mtds_asc" /></IonItem>
                  <IonItem><IonLabel>High to Low</IonLabel><IonRadio slot="end" value="mtds_desc" /></IonItem>
                </IonRadioGroup>
              </div>
            </IonAccordion>
          </IonAccordionGroup>
        </IonContent>
      </IonPopover>

      {/* Mobile Filter Drawer */}
      <IonModal
        isOpen={isMobileFilterDrawerOpen}
        onDidDismiss={() => setIsMobileFilterDrawerOpen(false)}
        className="mobile-filter-modal"
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Filters</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
          <IonAccordionGroup expand="first">
            <IonAccordion value="storetype-state">
              <IonItem slot="header"><b>Store Type</b></IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup
                  value={storeTypeFilter ?? "all"}
                  onIonChange={(e) =>
                    setStoreTypeFilter(e.detail.value === "all" ? null : e.detail.value)
                  }
                >
                  <IonItem><IonLabel>All</IonLabel><IonRadio slot="end" value="all" /></IonItem>
                  <IonItem><IonLabel>LTL</IonLabel><IonRadio slot="end" value="LTL" /></IonItem>
                  <IonItem><IonLabel>PTL</IonLabel><IonRadio slot="end" value="PTL" /></IonItem>
                  <IonItem><IonLabel>NEW_STORE</IonLabel><IonRadio slot="end" value="NEW_STORE" /></IonItem>
                </IonRadioGroup>
              </div>
            </IonAccordion>

            <IonAccordion value="sort">
              <IonItem slot="header"><b>Sort By</b></IonItem>
              <div className="ion-padding" slot="content">
                <IonAccordionGroup expand="inset">
                  <IonItem button onClick={() => handleDSort("default")}>Default</IonItem>
                  <IonAccordion value="ts">
                    <IonItem slot="header"><IonLabel>TS</IonLabel></IonItem>
                    <div className="ion-padding" slot="content">
                      <IonRadioGroup
                        value={selectedSortOption}
                        onIonChange={(e) => {
                          const value = e.detail.value;
                          setSelectedSortOption(value);
                          if (value === "ts_asc") handleAscSort("today_amt");
                          else if (value === "ts_desc") handleDesSort("today_amt");
                        }}
                      >
                        <IonItem><IonLabel>Low to High</IonLabel><IonRadio slot="end" value="ts_asc" /></IonItem>
                        <IonItem><IonLabel>High to Low</IonLabel><IonRadio slot="end" value="ts_desc" /></IonItem>
                      </IonRadioGroup>
                    </div>
                  </IonAccordion>
                  <IonAccordion value="ys">
                    <IonItem slot="header"><IonLabel>YS</IonLabel></IonItem>
                    <div className="ion-padding" slot="content">
                      <IonRadioGroup
                        value={selectedSortOption}
                        onIonChange={(e) => {
                          const value = e.detail.value;
                          setSelectedSortOption(value);
                          if (value === "ys_asc") handleAscSort("yesterday_amt");
                          else if (value === "ys_desc") handleDesSort("yesterday_amt");
                        }}
                      >
                        <IonItem><IonLabel>Low to High</IonLabel><IonRadio slot="end" value="ys_asc" /></IonItem>
                        <IonItem><IonLabel>High to Low</IonLabel><IonRadio slot="end" value="ys_desc" /></IonItem>
                      </IonRadioGroup>
                    </div>
                  </IonAccordion>
                  <IonAccordion value="ws">
                    <IonItem slot="header"><IonLabel>WTDS</IonLabel></IonItem>
                    <div className="ion-padding" slot="content">
                      <IonRadioGroup
                        value={selectedSortOption}
                        onIonChange={(e) => {
                          const value = e.detail.value;
                          setSelectedSortOption(value);
                          if (value === "wtds_asc") handleAscSort("this_week_amt");
                          else if (value === "wtds_desc") handleDesSort("this_week_amt");
                        }}
                      >
                        <IonItem><IonLabel>Low to High</IonLabel><IonRadio slot="end" value="wtds_asc" /></IonItem>
                        <IonItem><IonLabel>High to Low</IonLabel><IonRadio slot="end" value="wtds_desc" /></IonItem>
                      </IonRadioGroup>
                    </div>
                  </IonAccordion>
                  <IonAccordion value="ms">
                    <IonItem slot="header"><IonLabel>MTDS</IonLabel></IonItem>
                    <div className="ion-padding" slot="content">
                      <IonRadioGroup
                        value={selectedSortOption}
                        onIonChange={(e) => {
                          const value = e.detail.value;
                          setSelectedSortOption(value);
                          if (value === "mtds_asc") handleAscSort("this_month_amt");
                          else if (value === "mtds_desc") handleDesSort("this_month_amt");
                        }}
                      >
                        <IonItem><IonLabel>Low to High</IonLabel><IonRadio slot="end" value="mtds_asc" /></IonItem>
                        <IonItem><IonLabel>High to Low</IonLabel><IonRadio slot="end" value="mtds_desc" /></IonItem>
                      </IonRadioGroup>
                    </div>
                  </IonAccordion>
                </IonAccordionGroup>
              </div>
            </IonAccordion>
          </IonAccordionGroup>
        </IonContent>
        <IonFooter>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton
                color="medium"
                onClick={() => {
                  setStoreTypeFilter(null);
                  setSortState({ key: null, direction: null });
                  setSelectedSortOption(null);
                  handleDSort("default");
                }}
              >
                Clear Filters
              </IonButton>
            </IonButtons>
            <IonButtons slot="end">
              <IonButton color="primary" onClick={() => setIsMobileFilterDrawerOpen(false)}>
                Apply
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonFooter>
      </IonModal>

      {/* Mobile Search Modal */}
      <IonModal
        isOpen={isSearchModalOpen}
        onDidDismiss={() => setIsSearchModalOpen(false)}
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Search Region Name</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setIsSearchModalOpen(false)}>
                <IonIcon icon={closeOutline} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
          <IonItem>
            <IonIcon icon={searchOutline} slot="start" />
            <IonInput
              type="text"
              value={searchText}
              placeholder="Search Region name..."
              onIonInput={(e) => setSearchText(e.target.value)}
              clearInput
            />
          </IonItem>
          <IonGrid>
            <IonRow>
              <IonCol size="6">
                <IonButton expand="block" onClick={() => setIsSearchModalOpen(false)}>
                  Search
                </IonButton>
              </IonCol>
              <IonCol size="6">
                <IonButton
                  expand="block"
                  fill="outline"
                  color="medium"
                  onClick={() => {
                    setSearchText("");
                    setIsSearchModalOpen(false);
                  }}
                >
                  Clear
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
      </IonModal>
    </div>
  );
}
